<template lang="pug">
.form-giftVoucher.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.name" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.name }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="name" title="Nombre")
      .input-container
        input.input(v-model="dataForm.email" type="email" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.email }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="email" title="Email")

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

    form.add-manual-pays(@submit.prevent="")
      .input-container.arrow
        select.select(v-model="methodPay" autocomplete="ño" required)
          option(value="bancolombia") Bancolombia
          option(value="nequi") Nequi
          option(value="daviplata") Daviplata
        label.label(:class="{ show: methodPay }") Método de Pago

      shActionButton.button-pay(:isForm="true" :action="updateMethodPay" text="Actualizar Método de Pago" textRunning="Actualizando Método de Pago" :normalColor="true")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteGiftVoucher")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gql from '@my/graphql'
import gqlGiftVoucher from '@/graphql/giftVoucher'
import gqlArticleDefault from '@/graphql/articleDefault'
import shSelectList from '@/components/elements/SelectList'
import shInputImageList from '@/components/elements/InputImageList'
import shUploadImage from '@/components/pages/image/FormUpload'
import shDimensionsLines from '@/components/elements/DimensionLines.vue'
import modals from '@my/store/modals'

export default {
  name: 'FormGiftVoucher',

  mixins: [mForm, mFilters, mDB],

  components: { shSelectList, shInputImageList, shUploadImage, shDimensionsLines },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        phone: '',
        name: '',
        email: '',
        status: '',
        value: 0
      },
      giftVouchersRelated: [],
      msgArticleDefault: '',
      msgGiftVoucherRelated: '',
      resolver: 'giftVoucher',
      key: 'phone',
      gql: gqlGiftVoucher,
      gqlArticleDefault: gqlArticleDefault,
      delete: ['_id', 'createdAt', 'updatedAt', 'methodPay'],
      methodPay: ''
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newGiftVoucher()
      } else {
        this.updateGiftVoucher()
      }
    },

    newGiftVoucher () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateGiftVoucher () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteGiftVoucher () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    async updateMethodPay () {
      const mutation = gqlGiftVoucher.UPDATE_METHOD_PAY

      if (!this.dataForm.phone) return

      const response = await gql.mutate(mutation, { phone: this.dataForm.phone, methodPay: this.methodPay })

      if (response) {
        this.$store.commit('updateMethodPayGift', { phone: this.dataForm.phone, methodPay: this.methodPay })
        modals.showMessage({ message: `Se cambió el método de pago del bono para el número ${this.dataForm.phone} correctamente` })
      }
    }
  },

  watch: {
    dataOriginal: {
      handler () {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    },
    'dataForm.person': function (newVal) {
      this.dataForm.subfolder = newVal
      this.dataForm.folder = 'giftVouchers'
    }
  }
}
</script>

<style lang="stylus">
.form-giftVoucher
  position relative

.preview-text
  margin 1em 0

.title-stock
  font-weight 600
  font-size 1.1em
  margin 1em 0 .2em 0

.container-data-available
  padding 0 3em

.container-data-available > div
  display flex
  flex-direction column

.images-giftVoucher-container, .images-measure-container
  display flex
  flex-wrap wrap
  gap 1em
  flex-direction row
  justify-content center
  margin-bottom 2em

.images-giftVoucher-container > .image
  max-width 30em
  width 30%
  flex-shrink 0
  flex-basis 30em

.images-measure-container > .image
  max-width 40em
  width 30%
  flex-shrink 0
  flex-basis 40em

.images-giftVoucher-container > .image > img
  width 30em

.buttons-image
  display flex
  gap 1em
  justify-content center

.button-load
  opacity .4

.button-load:hover
  opacity 1
</style>



// WEBPACK FOOTER //
// src/components/pages/giftVoucher/Form.vue